import React from 'react';
import ReactMarkdown from 'react-markdown';

const OverallProgress = ({ summary }) => {
  // Debug log to check if the component is being rendered and what props it's receiving
  console.log('OverallProgress rendering with summary:', summary);
  
  // Remove the early return to always render something for debugging
  // if (!summary || summary.trim() === '') return null;

  // Function to properly format markdown text by replacing escaped newlines
  const formatMarkdown = (text) => {
    if (!text) return '';
    // Replace escaped newlines with actual newlines
    return text.replace(/\\n/g, '\n');
  };
  
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-6 pt-6 section-card page-item">
      <div className="bg-white rounded-xl border border-emerald-100 overflow-hidden  print:border-emerald-200">
        {/* Header */}
        <div className="bg-gradient-to-r from-emerald-500 to-emerald-600 px-6 py-3 flex items-center print:bg-emerald-500">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-5 w-5 text-white mr-2" 
            viewBox="0 0 20 20" 
            fill="currentColor"
          >
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
          </svg>
          <h3 className="text-lg font-bold text-white">Overall Progress</h3>
        </div>
        
        {/* Content */}
        <div className="p-6">
          <div className="flex">
            <div className="flex-shrink-0 hidden md:block print:block">
              <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center print:bg-emerald-50">
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="h-6 w-6 text-emerald-600" 
                  viewBox="0 0 20 20" 
                  fill="currentColor"
                >
                  <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            
            <div className="md:ml-4 flex-grow prose prose-emerald max-w-none">
              {summary ? (
                <div className="markdown-content" style={{ lineHeight: "1.6" }}>
                  <ReactMarkdown>{formatMarkdown(summary)}</ReactMarkdown>
                </div>
              ) : (
                <div className="bg-yellow-50 p-3 rounded border border-yellow-200 text-yellow-800">
                  <p><strong>Debug info:</strong> No overall summary available. Please make sure the report contains an <code>overallSummary</code> field.</p>
                </div>
              )}
            </div>
          </div>
          
          {/* Decorative elements for visual interest - PDF-friendly */}
          <div className="mt-4 pt-4 border-t border-gray-100 grid grid-cols-5 gap-1">
            {[...Array(5)].map((_, i) => (
              <div 
                key={`progress-bar-${i}`} 
                className="h-1.5 rounded-full" 
                style={{ 
                  backgroundColor: `rgb(${16 + i * 40}, ${185 - i * 5}, ${129 + i * 5})`,
                  opacity: 0.7 + i * 0.1
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverallProgress; 